import type { GetMessagesQueryVariables } from '#src/graphql/generated';

import { useMemo } from 'react';

import { buildGetMessagesVariables } from '#src/graphql/build-get-messages-variables';
import { useMessagesQueryPanel } from '#src/hooks/use-messages-query-panel';

export interface UseDocumentScopedMessagesOptions {
  /** When false, skips the messages query (e.g. drawer closed). */
  enabled: boolean;
}

export function useDocumentScopedMessages(
  documentId: string | undefined,
  { enabled }: UseDocumentScopedMessagesOptions,
) {
  const getMessagesVariables = useMemo<GetMessagesQueryVariables>(
    () =>
      buildGetMessagesVariables({
        kind: 'document',
        documentId: documentId ?? '',
      }),
    [documentId],
  );

  const skip = !documentId || !enabled;

  const panel = useMessagesQueryPanel({
    variables: getMessagesVariables,
    skip,
  });

  return {
    sortedMessages: panel.sortedMessages,
    displayMessages: panel.displayMessages,
    focusedRootId: panel.focusedRootId,
    isMessagesInitialLoad: panel.isMessagesInitialLoad,
    messagesError: panel.messagesError,
    refetchMessages: panel.refetchMessages,
    expandThread: panel.expandThread,
    collapseThread: panel.collapseThread,
    messagesFeatureActive: panel.messagesQueryActive,
    getMessagesVariables,
  };
}
